import {calculateErrorMessage} from 'common/helpers'

const ASSISTANT_INTRO_KEY = 'assistant-chatbot-intro-seen'

function storageKey(userId: string | undefined): string {
  return `${ASSISTANT_INTRO_KEY}:${userId}`
}

/** True once this user has opened the assistant at least once (drives the first-time pulse). */
export function hasSeenAssistantChatbotIntro(userId: string | undefined): boolean {
  if (!userId) return true
  try {
    return localStorage.getItem(storageKey(userId)) === 'true'
  } catch (e) {
    calculateErrorMessage(e)
    return true
  }
}

export function markAssistantChatbotIntroSeen(userId: string | undefined): void {
  if (!userId) return
  try {
    localStorage.setItem(storageKey(userId), 'true')
  } catch (e) {
    calculateErrorMessage(e)
  }
}
